import { Get } from "../components/Post";
import { GetCat } from "../components/Post/Get";
import { Head, Banner, Contact } from "../components/Project";
import { Grid, Space, Table } from "../components/Layout";
import { Title, Texts, Media, Button } from "../components/Object";
import { NewsList, WorksList, Pagination, SetDate, SetImg } from "../components/Post";
import { useParams } from "react-router-dom";
import { useDocumentLoadCompleted } from "../components/Hooks";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const Post = (props) => {
  const parms = useParams();

  const args = {
    postType: props.postType,
    type: props.type,
    id: parms.postId,
  };

  const isLoaded = useDocumentLoadCompleted();

  let cats;
  let catArgs;
  if (args.postType === "works") {
    catArgs = {
      slug: "works-cat",
    };
    cats = GetCat(catArgs);
  } else {
    catArgs = {
      slug: "categories",
    };
    cats = GetCat(catArgs);
  }
  const posts = Get(args);

  const Cat = (props) => {
    if (!cats) return true;
    const category = cats.find((cat) => cat.id == props.cat);
    let name = '';
    if (category) {
      name = category.name;
    } else {
      name = 'その他';
    }
    return (
      <>
        <div className="p-box__items--voice__cat">
          <p className="c-text__min c-text--bold">{name}</p>
        </div>
      </>
    );
  };

  return (
    <>
      <Head type="noimage" slug={props.postType}></Head>
      <div
        className="l-row"
        data-state={args.postType == "posts" ? "middle" : ""}
      >
        {/* title */}
        <AnimatePresence mode="wait">
          {posts && (
            <>
              <motion.div
                key={posts}
                layout
                animate={
                  isLoaded && {
                    opacity: 1,
                  }
                }
                initial={{
                  opacity: 0,
                }}
                exit={{
                  opacity: 0,
                }}
                transition={{
                  duration: 0.8,
                  // delay: location == '/' ? 1 : 0,
                }}
              >
                <div className="p-post__wrap--all">
                  <div className="p-post__wrap--top">
                    <div className="p-post__wrap--top__left">
                      <p
                        className="c-text__title-middle-24"
                        dangerouslySetInnerHTML={{
                          __html: posts.title.rendered,
                        }}
                      ></p>
                      <Space size={["32px 0 0px", "24px 0 0px"]}>
                        {/* date */}
                        <div className="p-box__items--voice__cat__wrap">
                          {posts[catArgs.slug].length > 0 ? (
                            posts[catArgs.slug].map((cat) => <Cat cat={cat} />)
                          ) : (
                            <div className="p-box__items--voice__cat">
                              <p className="c-text__min c-text--bold">その他</p>
                            </div>
                          )}
                        </div>
                        {args.postType !== "works" && (
                          <Space size={["32px 0 0px", "24px 0 0px"]}>
                            <p className="c-text--en c-text__min c-text--bold c-text--opacity5">
                              {SetDate(posts.date)}
                            </p>
                          </Space>
                        )}
                      </Space>
                    </div>

                    {args.postType == "works" && (
                      <>
                        <div className="p-post__wrap--top__bar"></div>
                        <div className="p-post__wrap--top__right">
                          <div className="p-post__wrap--top__right__inner">
                            <p className="c-text__bold">業種</p>
                            <p className="c-text__bold">{posts.acf.subject}</p>
                          </div>
                          <div className="p-post__wrap--top__right__inner">
                            <p className="c-text__bold">エリア</p>
                            <p className="c-text__bold">{posts.acf.area}</p>
                          </div>
                          <div className="p-post__wrap--top__right__inner">
                            <p className="c-text__bold">URL</p>
                            <Link to={posts.acf.url} target="_blank">
                              <p className="c-text__bold c-text--main">
                                {posts.acf.url}
                              </p>
                            </Link>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <Space size={["56px", "48px"]}></Space>
                {args.postType == "works" ? (
                  <div
                    dangerouslySetInnerHTML={{ __html: posts.content.rendered }}
                    className="c-text__normal p-post__wrap--body"
                  ></div>
                ) : (
                  <img
                    className="p-img__post"
                    data-state="posts"
                    src={SetImg(posts)}
                    alt="media"
                  />
                )}
                <Space size={["56px 0 64px", "48px 0 48px"]}>
                  {args.postType == "works" ? (
                    <img
                      className="p-img__post"
                      src={SetImg(posts)}
                      alt="media"
                      data-state="works"
                    />
                  ) : (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: posts.content.rendered,
                      }}
                      className="c-text__normal p-post__wrap--body"
                    ></div>
                  )}
                </Space>
              </motion.div>
            </>
          )}
        </AnimatePresence>
      </div>

      <div className="l-row">
        <Space size={["0 auto", "0 auto"]}>
          <Button type="" link={`/${props.postType}`} slug="return"></Button>
        </Space>
      </div>

      <Space size={["80px", "64px"]}></Space>
      {props.postType == "works" ? (
        <div className="l-row">
          <WorksList perPage={args.perPage} page={args.page}></WorksList>
        </div>
      ) : (
        <div className="l-row">
          <NewsList
            noimage={true}
            perPage={args.perPage}
            page={args.page}
          ></NewsList>
        </div>
      )}
      <Space size={["160px", "120px"]}></Space>
    </>
  );
};

export default Post;
